import { H1, LayoutBand, Separator } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { PersonBandSkeleton } from '@fs/zion-person-band'
import ResearchHelpContentSkeleton from './components/ResearchHelpContentSkeleton'

export default function DismissedHintsPageSkeleton(): JSX.Element {
  const [t] = useTranslation()
  return (
    <>
      <PersonBandSkeleton maxWidth="lg" marginX="xxs" hasBackButton disableColoredBackground />

      <LayoutBand maxWidth="lg" marginY="sm">
        <H1 size="H5">{t('research-help.dismissed-hints.label')}</H1>
        <Separator size="sm" />
        <ResearchHelpContentSkeleton />
      </LayoutBand>
    </>
  )
}
